import { http } from './http';
import { ROUTES } from './config';
import type { Tenant, TenantInput } from '../types/domain';

/** TenantsController client — the tenant registry itself (platform admin only). */
export const tenantsApi = {
  list(): Promise<Tenant[]> {
    return http.get(ROUTES.tenants.base);
  },

  get(id: string): Promise<Tenant> {
    return http.get(`${ROUTES.tenants.base}/${id}`);
  },

  create(body: TenantInput): Promise<{ id: string }> {
    return http.post(ROUTES.tenants.base, body);
  },

  update(id: string, body: TenantInput): Promise<void> {
    return http.put(`${ROUTES.tenants.base}/${id}`, body);
  },

  /** Deactivate, not delete — a tenant id is referenced by rows in every other service's
   * database (see TenantsController.Deactivate's own doc comment). */
  deactivate(id: string): Promise<void> {
    return http.post(ROUTES.tenants.deactivate(id), {});
  },
};
